import { faBars } from '@fortawesome/free-solid-svg-icons/faBars'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import { MAIN_MENU } from '../../config'
import SimpleIcon from '../../generic/components/SimpleIcon'

const MainMenuButton = ({ onClick, variant }) => {
  if (MAIN_MENU.length === 0) {
    return null
  }
  return (
    <button
      className={classnames('navbar-button', `navbar-button-${variant}`, 'navbar-button-toggler')}
      type='button'
      onClick={onClick}
      aria-label='Navigation bar'
    >
      <SimpleIcon icon={faBars} />
    </button>
  )
}

MainMenuButton.propTypes = {
  variant: PropTypes.oneOf(['left', 'right']),
  onClick: PropTypes.func
}

export default MainMenuButton
